import { Controller } from "@hotwired/stimulus"
import { readShareParams, getBaseCalculatorPath } from "../modules/salary_lab/url_state"
import { trackShare } from "../modules/salary_lab/ga4_tracker"

export default class extends Controller {
  static targets = ["feedback"]
  static values = { calculatorType: String }

  async copy() {
    let url
    try {
      url = await this._getShareUrl()
    } catch {
      url = window.location.href
    }

    try {
      await navigator.clipboard.writeText(url)
    } catch {
      this._fallbackCopy(url)
    }
    this._showFeedback("Link copied!")
    trackShare(this.calculatorTypeValue, "copy_link")
  }

  async _getShareUrl() {
    if (!this.hasCalculatorTypeValue || !this.calculatorTypeValue) {
      return window.location.href
    }

    const calcType = this.calculatorTypeValue
    const params = readShareParams(calcType)
    const body = { type: calcType, ...params }

    const basePath = getBaseCalculatorPath().replace(/\/+$/, "")
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const response = await fetch(`${basePath}/results/share`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {})
      },
      body: JSON.stringify(body)
    })

    if (!response.ok) throw new Error(`Share failed: ${response.status}`)

    const data = await response.json()
    return data.url
  }

  _fallbackCopy(text) {
    const input = document.createElement("input")
    input.value = text
    document.body.appendChild(input)
    input.select()
    document.execCommand("copy")
    document.body.removeChild(input)
    this._showFeedback("Link copied!")
  }

  _showFeedback(text) {
    if (!this.hasFeedbackTarget) return
    this.feedbackTarget.textContent = text
    this.feedbackTarget.classList.remove("hidden")
    setTimeout(() => {
      this.feedbackTarget.classList.add("hidden")
    }, 2000)
  }
}
